if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);


// --- Sunhauk upsell hook: bundle main product + upsell when toggle is ON ---
try {
  const productRoot = this.form.closest('.product-template-class');
  if (!productRoot) {
    // not on PDP or section wrapper missing – just skip upsell, let Dawn continue
    throw new Error('No .product-template-class root');
  }

  // our upsell row container
  const upsellRow = productRoot.querySelector('.sunhauk-upsell-row');

  // If there is no upsell on this product, do nothing and let normal flow continue
  if (upsellRow) {
    const upsellToggle    = upsellRow.querySelector('.sunhauk-upsell-toggle-input');
    const upsellVariantId = upsellRow.getAttribute('data-upsell-variant-id');

    if (!upsellToggle || !upsellVariantId) {
      throw new Error('Upsell toggle or variant id missing');
    }

    // Only bundle when toggle is ON
    if (upsellToggle.checked) {
      const mainId  = formData.get('id');
      const mainQty = formData.get('quantity') || 1;

      if (!mainId) {
        throw new Error('Main product id not found in formData');
      }

      // Remove the default single-line payload
      formData.delete('id');
      formData.delete('quantity');

      // items[0] = main product
      formData.append('items[0][id]', mainId);
      formData.append('items[0][quantity]', mainQty);

      // items[1] = upsell product
      formData.append('items[1][id]', upsellVariantId);
      formData.append('items[1][quantity]', mainQty);
    }
    // if toggle is OFF, we do nothing and let the default single-product payload go through
  }
} catch (e) {
  console.warn('Sunhauk upsell hook error', e);
}
// --- end Sunhauk upsell hook ---




        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
